import { Box, Typography, List, ListItem, ListItemIcon, ListItemText } from "@mui/material";

const PreSaleTermsPage = () => {
  return (
    <Box sx={{ maxWidth: 900, mx: 'auto', px: { xs: 2, md: 4 }, py: { xs: 6, md: 8 }, backgroundColor: '#FFFFFF' }}>
      <Typography variant='h4' sx={{ fontWeight: 800, mb: 2, color: '#1A2B4D' }}>BellHop Express | Botel Pre-Sale Reservation</Typography>
      <Typography sx={{ color: '#44536B', mb: 3 }}>
        You’re about to reserve your Botel.
        Please read carefully before completing your deposit:
      </Typography>

      <List sx={{ color: '#1A2B4D' }}>
        {[
          {
            title: 'Non-Refundable Deposit',
            lines: [
              'Your deposit is non-refundable.',
              'Deposits secure your place in the production and shipping queue.',
              'Funds are applied toward your total Botel purchase price.'
            ],
          },
          {
            title: 'Balance Due',
            lines: [
              'When your Botel is ready to schedule for delivery/installation, you will receive an invoice for the remaining balance.',
              'The balance must be paid in full within 7 days of invoice to maintain your reservation.'
            ],
          },
          {
            title: 'Shipping & Installation',
            lines: [
              'Shipping and installation costs are not included in your deposit or base unit price.',
              'These costs are billed separately at the time of delivery scheduling and vary by location.'
            ],
          },
          {
            title: 'Delivery Timeline',
            lines: [
              'Estimated delivery is 4–6 months, based on production volume and your place in line.',
              'Orders are fulfilled on a first-come, first-served basis.'
            ],
          },
          {
            title: 'Acknowledgment',
            lines: [
              'By placing your deposit, you acknowledge and agree to the above terms.',
            ],
          },
        ].map((item, idx) => (
          <ListItem key={idx} alignItems='flex-start' sx={{ mb: 2 }}>
            <ListItemIcon sx={{ minWidth: 24, pt: '6px' }}>
              <Box sx={{ width: 8, height: 8, borderRadius: '50%', bgcolor: '#FE6F61' }} />
            </ListItemIcon>
            <ListItemText
              primary={<Typography sx={{ fontWeight: 700, color: '#1A2B4D' }}>{item.title}</Typography>}
              secondary={
                <>
                  {item.lines.map((line, i) => (
                    <Typography key={i} component='span' sx={{ color: '#44536B', display: 'block', mt: i === 0 ? 0.5 : 0.75 }}>
                      {line}
                    </Typography>
                  ))}
                </>
              }
            />
          </ListItem>
        ))}
      </List>
    </Box>
  );
};

export default PreSaleTermsPage;


